/* eslint-disable @typescript-eslint/no-explicit-any */
import { ScModalFinalForm } from '@app/components/Base/ScFinalForm';
import { ISchoolInvoiceForm } from '@modules/school-service/interfaces/school-invoice-form.interface';
import useInvoiceFormPageStore from '../../hooks/usePageStore';
import { useMemo } from 'react';
import CompanyInfoTab from './Tabs/CompanyInfoTab';
import ScTabs from '@app/components/UI/ScTabs';
import ReportInfoTab from './Tabs/ReportInfoTab';
import validate from './validate';
import { useUpdateInvoiceFormMutation } from '../../hooks/usePageQuery';
import alertUtils from '@app/utils/alert';

const InvoiceFormUpdatePopup = () => {
    const { isOpenPopup, editItem, closePopup } = useInvoiceFormPageStore();
    const { mutateAsync } = useUpdateInvoiceFormMutation();

    const tabItems = useMemo(
        () => [
            {
                label: 'Thông tin mẫu hóa đơn',
                key: 'report-info',
                children: <ReportInfoTab />,
            },
            {
                label: 'Thông tin nhà cung cấp thực phẩm',
                key: 'company-info',
                children: <CompanyInfoTab />,
            },
        ],
        [],
    );

    const onSubmit = async (values: ISchoolInvoiceForm) => {
        try {
            await mutateAsync(values);
            alertUtils.showSuccess('Chỉnh sửa thành công');
            closePopup();
        } catch (error: any) {
            alertUtils.showError(
                error?.message || 'Có lỗi xảy ra, vui lòng thử lại',
            );
        }
    };

    return (
        <ScModalFinalForm<ISchoolInvoiceForm>
            title="Chỉnh sửa mẫu hóa đơn"
            open={isOpenPopup}
            onClose={closePopup}
            onSubmit={onSubmit}
            initialValues={editItem as ISchoolInvoiceForm}
            width={900}
            className="full-height"
            validate={validate}
        >
            <ScTabs items={tabItems} defaultActiveKey="company-info" />
        </ScModalFinalForm>
    );
};

export default InvoiceFormUpdatePopup;
